import { CoreData } from '@carvana/merch-tile';
import TagId from '~/constants/srp/TagId';
import type { RecommendedVehicle } from '~/contracts/common';

type VehicleArrayType = CoreData[] | RecommendedVehicle[];

export default function includesEvVehicle(vehicles: VehicleArrayType) {
  return vehicles.some(v =>
    v.vehicleTags.some(t => t.tagId === TagId.EVCredit)
  );
}
